module.exports = __webpack_public_path__ + "img/img12.53b902d0.png";